<template>
  <div class="myuploader-2">
    <van-cell-group class="uploader-box" :border="false">
      <template #title>
        <div v-html="title"></div>
      </template>
      <div class="words" v-if="words" style="color: rgba(69, 90, 100, 0.6);">{{words}}</div>
      <div class="uploader-subbox" v-if="showTemp && temp.length>0">
        <div class="uploader-subtitle">示例图片</div>
        <van-row type="flex" gutter="20">
          <van-col @click="showPic(temp)">
            <van-image width="120" fit="contain" height="80" :src="temp" />
            <!-- <div class="text">示例1</div> -->
          </van-col>
        </van-row>
      </div>

      <div class="uploader-subbox" v-if="showHistory && history.length>0">
        <div class="uploader-subtitle">已上传图片</div>
        <van-row>
          <van-col v-for="(hitem, hindex) in history" :key="hindex" @click="showPic(history, hindex)">
            <van-image width="80" fit="contain" height="80" :src="hitem.filepath">
              <!-- <i class="van-icon van-icon-clear van-uploader__preview-delete"
                v-if="hitem.is_check == '0'||hitem.checked == '0'" @click.stop="deleteImg(hitem.id)"></i> -->
            </van-image>
          </van-col>
        </van-row>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Toast,
    ImagePreview,
    Dialog
  } from 'vant'
  import defaultImage from '@/assets/image.jpg'
  import {
    DeleteImg,
    deleteCheckItem
  } from '@/api/api'
    import { DownloadImage } from '@/api/patient'
      
  Vue.use(Toast)
  Vue.use(ImagePreview)
  Vue.use(Dialog)

  export default {
    name: 'ImageUploader',
    props: {
      value: {
        type: Array
      },
      //   prevImages: {
      //       type: Array,
      //       default: []
      //   },
      title: {
        type: String,
        default: '上传图片'
      },
      note: {
        type: String,
        default: ''
      },
      num: {
        type: Number,
        default: 1
      },
      showTemp: {
        type: Boolean,
        default: true
      },
      temp: {
        type: String,
        default: ''
      },
      showHistory: {
        type: Boolean,
        default: true
      },
      history: {
        type: Array,
        default: ()=>[]
      },
      words: {
        type: String,
        default: ''
      },
      sourceType: {
        type: Array,
        default:()=>['album', 'camera']// 可以指定来源是相册还是相机，默认二者都有
      }, 
    },
    data() {
      return {
        defaultImage: defaultImage,
        images: [],
        src: [],
        isLoading: false
      };
    },
    // computed: {
    //   canUp() {
    //     if (this.num == 1 && (this.num - this.history.length - this.images.length) > 0) {
    //       return true
    //     } else {
    //       return false
    //     }
    //   }
    // },
    created() {
      this.images = this.value
    },
    methods: {
      showPic(route, index) {
        this.src = []
        if (Array.isArray(route)) {
          route.forEach(ele => {
            this.src.push(ele.filepath)
          })
        } else {
          this.src.push(route)
        }
        this.$nextTick(() => {
          ImagePreview({
            images: this.src,
            showIndex: true,
            loop: false,
            startPosition: index ? index : 0,
          })
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .myuploader-2 {
    .van-cell-group__title {
      padding: 10px;
      font-size: 16px;
      color: #333;
    }

    .uploader-box {
      box-sizing: border-box;
      padding: 10px 15px;
      // border-top: 1px solid rgba(0,0,0,0.07);
      // border-bottom: 1px solid rgba(0,0,0,0.07);
      overflow: hidden;

      .uploader-subbox {
        border-bottom: #eee solid 1px;
        margin-bottom: 20px;

        .text {
          margin-top: 5px;
          color: #666;
          text-align: center;
        }

        .van-col {
          margin-bottom: 15px;
          position: relative;
          margin-right: 10px;
        }
      }

      .uploader-subtitle {
        margin: 0;
        padding: 0 0px 16px !important;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
      }

      .uploader-subbox:first-child {
        .uploader-subtitle {
          padding-top: 0;
        }
      }

      .uploader-subbox:last-child {
        margin-bottom: 0;
        border-bottom-width: 0;
      }
    }

    .van-image {
      background: #f6f6f6;
    }
    .van-uploader__preview-delete {
      background: transparent; color: #aaa; font-size: 16px; height: 16px; width: 16px; border-radius: 16px; top: -6px; right: -6px; box-shadow: 0 0 0 1px #fff;
    }
  }

.van-overlay {
    background-color: rgba(0, 0, 0, 0.6);
}
</style>